const arrOfServices = [
    {
        text:
            'Nemo cupiditate ab quibusdam quaerat impedit magni. Earum suscipit ipsum laudantium.Quo delectus est.Maiores voluptas ab sit natus veritatis ut.Debitis nulla cumque veritatis.Sunt suscipit voluptas ipsa in tempora esse soluta sint.',
        icon: 'fas fa-paint-brush',
        title: 'Brand Identity'
    },
    {
        text:
            'Nemo cupiditate ab quibusdam quaerat impedit magni. Earum suscipit ipsum laudantium.Quo delectus est.Maiores voluptas ab sit natus veritatis ut.Debitis nulla cumque veritatis.Sunt suscipit voluptas ipsa in tempora esse soluta sint.',
        icon: 'fas fa-object-group',
        title: 'Illustration'
    },
    {
        text:
            'Nemo cupiditate ab quibusdam quaerat impedit magni. Earum suscipit ipsum laudantium.Quo delectus est.Maiores voluptas ab sit natus veritatis ut.Debitis nulla cumque veritatis.Sunt suscipit voluptas ipsa in tempora esse soluta sint.',
        icon: 'fas fa-bullhorn',
        title: 'Marketing'
    },
    {
        text:
            'Nemo cupiditate ab quibusdam quaerat impedit magni. Earum suscipit ipsum laudantium.Quo delectus est.Maiores voluptas ab sit natus veritatis ut.Debitis nulla cumque veritatis.Sunt suscipit voluptas ipsa in tempora esse soluta sint.',
        icon: 'fas fa-globe-americas',
        title: 'Web Design'
    },
    {
        text:
            'Nemo cupiditate ab quibusdam quaerat impedit magni. Earum suscipit ipsum laudantium.Quo delectus est.Maiores voluptas ab sit natus veritatis ut.Debitis nulla cumque veritatis.Sunt suscipit voluptas ipsa in tempora esse soluta sint.',
        icon: 'fas fa-cube',
        title: 'Packaging Design'
    },
    {
        text:
            'Nemo cupiditate ab quibusdam quaerat impedit magni. Earum suscipit ipsum laudantium.Quo delectus est.Maiores voluptas ab sit natus veritatis ut.Debitis nulla cumque veritatis.Sunt suscipit voluptas ipsa in tempora esse soluta sint.',
        icon: 'fas fa-shapes',
        title: 'Web Development'
    }
];

export default arrOfServices